import React from 'react';
import Workflow from '../features/workflow/Workflow';

export default function WorkflowPage() {
  return <Workflow />;

}
